import React from 'react';
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/competitor-container.module.scss";
import {SideBarModuleAsync} from "../../../apps/website/modules/side-bar-module/components/side-bar-module.async";

export const CompetitorContainerSideBar = observer(({controller}) => {
  const {state} = controller;
  const {shouldRenderSideBar} = state

  return shouldRenderSideBar ? <div className={classNames(styles.side_bar)}>
    <SideBarModuleAsync/>
  </div> : null
})
